import useNetwork from '@/hooks/useNetwork';
import { event_networkId } from '@/utils/query-helpers';

export default function useNetworkFilter() {
  const network = useNetwork();

  return {
    ...event_networkId(network)
  };
};
